<!-- section template -->
<template>
  <Layout>
    <BaseBannerJtails :title="bannerTitle" :image="bannerImage" />
    <section :class="[$style.viewDeposit, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
      <div class="container">
        <div class="row">
          <div class="col-md-7 col-lg-8 viewDeposit__leftBox">
            <div class="section">
              <div class="viewDeposit__image" :style="{ backgroundImage: `url('${image}')` }"></div>
              <template v-if="!!description">
                <BaseSectionTitleJtails v-if="!$globalIsDingBeauty" title="方案說明" title-class="text-primary-dark" sub-title="Instruction" />
                <BaseSectionTitleSecondary v-else title="方案說明" />
                <div class="viewDeposit__description" v-html="nlToBr(description)"></div>
              </template>
              <BaseTab v-model="activeTab" :tab-list="tabList" name="activeTab" />
              <Deposit v-show="activeTab === 'deposit'" v-model="submitData" :deposit-list="list" class="mt-md-5" />
              <Applicable v-show="activeTab === 'applicable'" class="mt-md-5" />

              <div v-show="activeTab === 'notice'" class="viewDeposit__description mt-md-5" v-html="nlToBr(description)"> </div>
            </div>
          </div>
          <div class="col-md-5 col-lg-4 viewDeposit__rightBox">
            <BaseSticky :offset="-60" :menu-height="90" :space-top="106" :space-bottom="40">
              <InfoBox :deposit-item="submitData" class="viewDeposit__infoBox" />
            </BaseSticky>
          </div>
        </div>
      </div>
    </section>
    <!-- <BasePre>commentItem: {{ commentItem }}</BasePre> -->
  </Layout>
</template>

<script>
import { nlToBr } from '@utils'
import { merchantComputed, authComputed } from '@store/helpers'
import store from '@store'

export default {
  nmae:'index3',
  page() {
    return {
      title: this.currentMerchant?.depositSetting?.title || '儲值方案',
    }
  },
  components: {
    Layout: () => import('@layout/main'),
    InfoBox: () => import('./components/SectionInfoBox.Jtails'),
    Deposit: () => import('./components/SectionContent.Jtails'),
    Applicable: () => import('./components/SectionApplicable.Jtails'),
  },
  // props: {
  //   list: {
  //     type: Array,
  //     required: true
  //   },
  // },
  data() {
    return {
      list: [],
      activeTab: 'deposit',
      loadingStoreCart: false,
      submitData: {
        uuid: '',
        title: '',
        description: null,
        point: 0,
        price: 0,
        keepTop: 0,
        mode: 'selling',
        state: 1,
        canBuy: true,
      },
      tabList: Object.freeze([
        {
          title: '儲值方案',
          name: 'deposit',
        },
        {
          title: '適用範圍',
          name: 'applicable',
        },
        {
          title: '注意事項',
          name: 'notice',
        },
      ]),
    }
  },

  computed: {
    ...merchantComputed,
    ...authComputed,
    bannerImage() {
      if (this.currentMerchant.depositSetting.bannerImages.length > 0) {
        return this.currentMerchant.depositSetting.bannerImages[0].path
      } else {
        return require(`@assets/images/${this.$globalProjectName}/deposit/coin.jpg`)
      }
    },
    bannerTitle() {
      return this.currentMerchant?.depositSetting?.title || '儲值方案'
    },
    image() {
      return this.currentMerchant?.depositSetting?.images.length > 0
        ? this.currentMerchant.depositSetting.images[0]['path']
        : this.$globalIsDingBeauty
        ? require(`@assets/images/dingbeauty/deposit/image@2.jpg`)
        : require(`@assets/images/default/plan-default-Image@2x.png`)
    },
    description() {
      return this.currentMerchant?.depositSetting?.description || ''
    },
  },
  mounted() {
    if (this.isLoggedIn) {
      this.fetchDepositData()
    }
  },
  methods: {
    nlToBr,

    async fetchDepositData() {
      const [list] = await Promise.all([store.dispatch('deposit/fetchDeposit')])
      this.list = list
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.viewDeposit {
  position: relative;

  :global {
    .viewDeposit {
      &__image {
        background-position: center;
        background-size: cover;
        padding-top: 38.23%;
        margin-bottom: 2.5rem;
        border-radius: 20px;
      }

      &__description {
        font-size: 1rem;
        line-height: 1.75rem;
        letter-spacing: 0.15rem;
        margin-bottom: 1.5rem;
        color: $color-gray-2;
      }
      &__infoBox {
        @include max-md {
          position: fixed;
          top: auto;
          bottom: 0;
          left: 0;
          z-index: 999;
          width: 100%;
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .viewDeposit {
        &__image {
          border-radius: 0;
        }
      }
    }
  }
}
</style>
